import FingerprintJS from "@fingerprintjs/fingerprintjs";
import axios from "axios";
import { backendUrl } from "./api";

const authEndpoint = `${backendUrl}/api/auth`;

export const authLogin = async (credentials: any): Promise<any> => {
	const fp = await FingerprintJS.load();
	const result = await fp.get();
	const visitorId = result.visitorId;

	credentials = { ...credentials, deviceFingerPrint: visitorId };

	const response = await axios.post(`${authEndpoint}/login`, credentials);
	return response;
};

export const authRefreshToken = async (refreshToken: any): Promise<any> => {
	const response = await axios.post(`${authEndpoint}/refresh`, {
		refreshToken,
	});
	return response;
};

export const createPassword = async (credentials: any): Promise<any> => {
	return await axios.post(`${backendUrl}/api/auth/reset-password`, credentials);
};

// Plain axios: the interceptor would refresh an expired session first, minting a token
// only to revoke it. The BE ends the session named by the refresh token alone.
export const authLogout = async (refreshToken: string | null): Promise<any> => {
	const response = await axios.post(`${authEndpoint}/logout`, {
		refreshToken,
	});
	return response;
};

export const resetPassword = async (credentials: any): Promise<any> => {
	const response = await axios.post(
		`${authEndpoint}/reset-password`,
		credentials
	);
	return response;
};

export const forgotPassword = async (emailAddress: string): Promise<any> => {
	const response = await axios.post(`${authEndpoint}/forgot-password`, {
		email: emailAddress,
		websiteUrl: window.location.origin,
	});
	return response;
};

// Initiate domain-based SSO login (no email required)
export const initiateDomainSSOLogin = async (
	request: SSODomainLoginRequest
): Promise<SSOLoginResponse> => {
	const response = await axios.post(
		`${authEndpoint}/sso/initiate-domain`,
		request
	);
	return response.data;
};

// Process SSO callback
export const processSSOCallback = async (
	code: string,
	state: string
): Promise<any> => {
	const response = await axios.get(`${authEndpoint}/sso/callback`, {
		params: { code, state },
	});
	return response.data;
};

export interface SSOLoginRequest {
	email: string;
	redirectUri?: string;
}

export interface SSODomainLoginRequest {
	redirectUri?: string;
}

export interface SSOLoginResponse {
	authorizationUrl: string;
	state: string;
	provider?: string;
}
